<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Homework"
}
</script>

<style>

</style>